/** The curated faces' URLs (decision 31), apart from the worker's own module so a page can name them without loading it. */
import { FONT_FILES } from 'virtual:layout-files';
import { fileUrls } from './assets.ts';

/** Every curated face's URL, by file name (decision 31: fetched only when a theme needs it). */
export const FONT_URLS = fileUrls(FONT_FILES);
